import type { APIUserProp, GameStatus, PublicTournamentGame } from '../../services/interfaces/propsService/api';
import type { TUserProp } from '../../services/interfaces/propsService/parsed/props';
import { getRoundFromMeta } from '../../services/interfaces/propsService/api/propMeta';

export type UIPropStatus =
  | 'won'
  | 'lost'
  | 'push'
  | 'live'
  | 'live_winning_over'
  | 'live_losing_under'
  | 'disabled'
  | 'alternate'
  | 'survivor-prop-won'
  | 'survivor-prop-lost'
  | 'survivor-prop-na'
  | undefined;

export function getEventStatus(prop: TUserProp | APIUserProp): GameStatus {
  const round = getRoundFromMeta(prop.meta);

  if (round) {
    const game = prop.game as PublicTournamentGame;
    const roundStatus = game?.state?.rounds?.find((r) => r.number === round)?.status;
    if (roundStatus) return roundStatus;
  }

  return prop.game.status;
}

export const parsePropStatus = (prop: TUserProp | APIUserProp): UIPropStatus => {
  if (prop.status === 'disabled') {
    return 'disabled';
  }

  const eventStatus = getEventStatus(prop);

  if (!['SCHEDULED', 'FINALIZED', 'CANCELED'].includes(eventStatus)) {
    if (prop.score > prop.line) {
      if (prop.direction === 'under') {
        return 'live_losing_under';
      }
      return 'live_winning_over';
    }
    return 'live';
  }
  if (!prop.final_direction) {
    return undefined;
  }
  if (prop.final_direction === 'push') {
    return 'push';
  }
  if (prop.final_direction === prop.direction) {
    return 'won';
  }
  return 'lost';
};
